import { root } from './delete';

export const _delete = {
  ...root,
};
